import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface CustomerProfile {
  id: string;
  email: string;
  name: string;
  phone: string;
  address: string;
  addressLocality: string;
  addressProvince: string;
  addressPostalCode: string;
}

interface CustomerAuthState {
  token: string | null;
  customer: CustomerProfile | null;
}

const STORAGE_KEY = 'aye_customer_token';

function loadToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

const initialState: CustomerAuthState = { token: loadToken(), customer: null };

const customerAuthSlice = createSlice({
  name: 'customerAuth',
  initialState,
  reducers: {
    setCustomerAuth(state, { payload }: PayloadAction<{ token: string; customer: CustomerProfile }>) {
      state.token = payload.token;
      state.customer = payload.customer;
      try { localStorage.setItem(STORAGE_KEY, payload.token); } catch { /* localStorage no disponible */ }
    },
    setCustomerProfile(state, { payload }: PayloadAction<CustomerProfile>) {
      state.customer = payload;
    },
    clearCustomerAuth(state) {
      state.token = null;
      state.customer = null;
      try { localStorage.removeItem(STORAGE_KEY); } catch { /* localStorage no disponible */ }
    },
  },
});

export const { setCustomerAuth, setCustomerProfile, clearCustomerAuth } = customerAuthSlice.actions;
export default customerAuthSlice.reducer;
